import moment from "moment";

export const getTime = (time_str)=>{
    const input = moment(time_str);
    let result = moment().isSame(input, "day")
  ? moment(input).format("h:mm A")
  : moment(input).format("DD/MM/YYYY");
  return result
  }

 export const getTimeFromNow = (time_str)=>{
    const input = moment(time_str);
    return input.fromNow()
  }